import { render, staticRenderFns } from "./app.vue?vue&type=template&id=dfb4b8ac"
import script from "./app.ts?vue&type=script&lang=js&external"
export * from "./app.ts?vue&type=script&lang=js&external"
import style0 from "@/assets/styles/style.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports